export const compensationTemplate = {
  delay_1h_or_more: null,
  processing_fee: null,
  requested_refund: null,
  additional_details: "",
  link_to_ticket: null,
  link_to_generated_document: null,
  status: "draft",
};
